import React from "react"
import Base  from "./base"

// Components
import Combobox from "@shared/combobox"

export default class Contact extends Base {
  constructor(props) {
    super(props)
    this.state = {active: !props.quote.contact.id}
    this.onSelectContact = this.onSelectContact.bind(this)
  }

  onSelectContact(contact) {
    const { quote, replaceQuote } = this.props
    this.deactivate()
    replaceQuote({...quote, contact: contact || {}})
  }

  render() {
    const { quote, replaceQuote } = this.props
    const site    = quote.site
    const contact = quote.contact

    return(
      this.state.active || !contact.id
        ? site.id && site.contacts?.length > 0
          ? <div className="form-group">
              <label>{I18n.t("workorders.contact")}</label>

              <Combobox
                fieldName       = "quote[contact_id]"
                options         = {site.contacts}
                value           = {contact.id}
                placeholder     = {I18n.t("workorders.select_contact")}
                onSelectElement = {this.onSelectContact}
                onReset         = {() => replaceQuote({...quote, contact: {}})}
                resetIcon
              />
            </div>
          : <input
              type="hidden"
              name="quote[contact_id]"
              defaultValue={null}
            />
        : <div className="quotes--form-pointer pt-0 pb-0" onClick={this.activate}>
            <div>{contact.display}</div>
            <input
              type="hidden"
              name="quote[contact_id]"
              defaultValue={contact.id}
            />
          </div>
    )
  }
}
